import { httpHandler } from '../httpHandler'

export const post = body => httpHandler.post({url: '/company/branches/employee', options: { body } });
export const put = (code, body) => httpHandler.put({ url: `/company/branches/employee/${code}`, options: { body } });
export const get = (body) => httpHandler.get({url: '/company/employees', params: body});
export const getAutocomplete = (Text) => httpHandler.get({url: '/company/employees', params: {Text, SelectedPage: 1}});
